/* istanbul ignore file */

import { LogLevel } from "./log-level";
import { ILogger } from "./logger";

export default abstract class LoggerBase implements ILogger {
    minimumLogLevel: LogLevel = LogLevel.Info;

    get isDebugEnabled(): boolean {
        return this.minimumLogLevel <= LogLevel.Debug;
    }

    get isInfoEnabled(): boolean {
        return this.minimumLogLevel <= LogLevel.Info;
    }

    get isWarnEnabled(): boolean {
        return this.minimumLogLevel <= LogLevel.Warn;
    }

    get isErrorEnabled(): boolean {
        return this.minimumLogLevel <= LogLevel.Error;
    }

    debug(message: (() => string) | string): void {
        if (this.isDebugEnabled) {
            this.handleDebugMessage(typeof message === "function" ? message() : message);
        }
    }

    async debugAsync(message: () => Promise<string>): Promise<void> {
        if (this.isDebugEnabled) {
            const msg = await message();
            this.handleDebugMessage(msg);
        }
    }

    info(message: (() => string) | string): void {
        if (this.isInfoEnabled) {
            this.handleInfoMessage(typeof message === "function" ? message() : message);
        }
    }

    async infoAsync(message: () => Promise<string>): Promise<void> {
        if (this.isInfoEnabled) {
            const msg = await message();
            this.handleInfoMessage(msg);
        }
    }

    warn(message: (() => string) | string): void {
        if (this.isWarnEnabled) {
            this.handleWarnMessage(typeof message === "function" ? message() : message);
        }
    }

    async warnAsync(message: () => Promise<string>): Promise<void> {
        if (this.isWarnEnabled) {
            const msg = await message();
            this.handleWarnMessage(msg);
        }
    }

    error(message: (() => string) | string, error?: Error): void {
        if (this.isErrorEnabled) {
            this.handleErrorMessage(typeof message === "function" ? message() : message, error);
        }
    }

    async errorAsync(message: () => Promise<string>, error?: Error): Promise<void> {
        if (this.isErrorEnabled) {
            const msg = await message();
            this.handleErrorMessage(msg, error);
        }
    }

    abstract logDebug(message: string): void;
    abstract logInfo(message: string): void;
    abstract logWarn(message: string): void;
    abstract logError(message: string, error?: Error): void;
    abstract logError(error: Error): void;

    private handleDebugMessage(message: string): void {
        //TODO Fire event?

        this.logDebug(message);
    }

    private handleInfoMessage(message: string): void {
        //TODO Fire event?

        this.logInfo(message);
    }

    private handleWarnMessage(message: string): void {
        //TODO Fire event?

        this.logWarn(message);
    }

    private handleErrorMessage(message: string, error?: Error): void {
        //TODO Fire event?

        this.logError(message, error);
    }
}
